let pending = 0;

/**
 * Whether an {@link importOptional} call is still loading.
 *
 * The `vite:preloadError` handler in main.tsx reads this: a failed chunk
 * normally reloads the page, which is wrong for one the page works without.
 * @returns True while at least one optional import is in flight.
 */
export function isOptionalImportPending(): boolean {
  return pending > 0;
}

/**
 * Loads a chunk the page can do without. A failure resolves to `undefined`
 * instead of rejecting, and doesn't trigger the stale-chunk page reload.
 * @param load - The dynamic import, e.g. `() => import('lib/some-module')`.
 * @returns The module, or `undefined` if it could not be loaded.
 */
export async function importOptional<T>(
  load: () => Promise<T>,
): Promise<T | undefined> {
  pending += 1;
  try {
    return await load();
  } catch {
    return undefined;
  } finally {
    pending -= 1;
  }
}
